// BarChart.jsx
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function BarChart({ labels, dataset1, dataset2, label1, label2 }) {
  const data = {
    labels,
    datasets: [
      {
        label: label1,
        data: dataset1,
        backgroundColor: "#36a2eb",
      },
      {
        label: label2,
        data: dataset2,
        backgroundColor: "#ff6384",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
      },
    },
  };

  return <Bar data={data} options={options} />;
}

export default BarChart;
